<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <div class="flex items-start justify-between gap-3 flex-wrap">
      <div>
        <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Mes documents</h1>
        <p class="text-gray-500 mt-1">Fichiers déposés dans votre espace (stockage sécurisé).</p>
      </div>
      <label
        class="inline-flex items-center gap-2 px-4 py-2 bg-secondary text-white text-sm font-medium rounded-md cursor-pointer hover:bg-secondary-hover"
        [class.opacity-60]="busy()"
        [class.pointer-events-none]="busy()"
      >
        @if (uploading()) { Envoi... } @else { Uploader }
        <input type="file" class="hidden" (change)="onFileSelected($event)" [disabled]="busy()" />
      </label>
    </div>

    <article class="rounded-xl border border-gray-200 bg-white overflow-hidden min-h-[220px]">
      @if (busy()) {
        <div class="flex flex-col items-center justify-center gap-3 py-16 px-4">
          <span class="material-symbols-outlined text-secondary text-5xl animate-spin">progress_activity</span>
          <p class="text-sm text-gray-600">{{ busyMessage() }}</p>
        </div>
      } @else if (!rows().length) {
        <div class="p-10 text-center">
          <p class="text-sm text-gray-500">Aucun document</p>
          <p class="text-xs text-gray-500 mt-1">Uploadez vos documents pour les retrouver ici.</p>
        </div>
      } @else {
        <table class="w-full text-sm">
          <thead class="bg-gray-50 text-gray-600">
            <tr>
              <th class="text-left px-4 py-3 font-medium">Document</th>
              <th class="text-left px-4 py-3 font-medium">Client</th>
              <th class="text-left px-4 py-3 font-medium">Date</th>
              <th class="text-left px-4 py-3 font-medium">Taille</th>
              <th class="text-right px-4 py-3 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            @for (row of rows(); track row.file.id) {
              <tr>
                <td class="px-4 py-3 text-gray-800">{{ fileEmoji(row.file.contentType) }} {{ row.file.originalFilename }}</td>
                <td class="px-4 py-3">
                  <p class="font-medium text-gray-900">{{ row.company.nomEntreprise }}</p>
                  <p class="text-xs text-gray-500">{{ row.company.siretFormatte }}</p>
                </td>
                <td class="px-4 py-3 text-gray-500">{{ row.file.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td class="px-4 py-3 text-gray-500">{{ formatSize(row.file.sizeBytes) }}</td>
                <td class="px-4 py-3 text-right">
                  <div class="inline-flex items-center gap-2 justify-end">
                    <button
                      type="button"
                      (click)="download(row)"
                      title="Télécharger"
                      aria-label="Télécharger"
                      class="p-1.5 text-secondary hover:bg-secondary/10 rounded-md cursor-pointer"
                    >
                      <span class="material-symbols-outlined text-[22px]">download</span>
                    </button>
                    <button
                      type="button"
                      (click)="delete(row)"
                      title="Supprimer"
                      aria-label="Supprimer"
                      class="p-1.5 text-red-600 hover:bg-red-50 rounded-md cursor-pointer"
                    >
                      <span class="material-symbols-outlined text-[22px]">delete</span>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </article>
  </div>
</section>
